{
  "price_editor": {
    "title": "Edit prices"
  },
  "coupon_code": {
    "title": "Enter coupon code"
  },
  "select_customer": {
    "title": "Select a customer",
    "login": "Login"
  },
  "customer_table": {
    "title": "B2B customers",
    "columns": {
      "name": "Name",
      "email": "Email",
      "group": "Group"
    }
  },
  "discount_coupon": {
    "title": "Coupon codes"
  },
  "order_amount_limits": {
    "minimum": "Minimum order amount",
    "maximum": "Maximum order amount"
  }
}
